
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21.6 18.9"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.2 4.3c.2.3.5.5.9.3.3-.2.5-.5.3-.9-1-2.3-3.3-3.8-5.8-3.8h-.1c-3.4.1-6.3 3-6.4 6.5v3.8l-3-3C.9 7 .5 7 .2 7.2c-.3.3-.3.7 0 1l4.1 4.1c.1.1.3.2.5.2s.3-.1.5-.2l4.1-4.1c.3-.3.3-.7 0-1-.2-.2-.7-.2-.9 0l-3 3V6.5c0-2.8 2.3-5.1 5.1-5.1h.1c1.9-.1 3.7 1.1 4.5 2.9zm5.7 8.8H17V9.2c0-.4-.3-.7-.7-.7-.4 0-.7.3-.7.7V13h-3.8c-.4 0-.7.3-.7.7s.3.7.7.7h3.8v3.8c0 .4.3.7.7.7.4 0 .7-.3.7-.7v-3.8h3.8c.4 0 .7-.3.7-.7s-.2-.6-.6-.6z","fill":"#444445"}})])
          )
        }
      }
    